import { Fragment, isValidElement } from 'react';
import type React from 'react';

// A truthiness check would drop `0`, which React does render. Booleans, empty arrays and
// empty fragments are how an absent slot actually arrives — `cond && <X />`, `items.map(...)`.
export const isRenderableNode = (node: React.ReactNode): boolean => {
    if (node === undefined || node === null || typeof node === 'boolean' || node === '') {
        return false;
    }

    if (Array.isArray(node)) {
        return node.some(isRenderableNode);
    }

    if (isValidElement(node) && node.type === Fragment) {
        return isRenderableNode((node.props as { children?: React.ReactNode }).children);
    }

    return true;
};
